/*

{"userLoop": {"completed": true, "__typename": "UserLoop", "userQuestions": ""}, "__typename": "PropertyUpdates", "contextNote": null, "previousContext": " Previous Context: Update contact's first name to \"Pri\" as the preferred name to be used everywhere{\"updateableProperties\":[{\"propertyId\":\"firstName\",\"propertyName\":\"First Name\",\"reasoning\":\"The new information explicitly states 'Update contact's first name to Pri as the preferred name to be used everywhere'. The current object state already shows the first name as 'Pri', so this is a confirmation of the existing value.\"}],\"createContextNote\":false,\"noTargetProperties\":true,\"targetPropertiesAdditionalInformationRequested\":[],\"completed\":true,\"userQuestions\":\"\",\"additionalInformationRequested\":[]}\n Current Context: Update contact's first name to \"Pri\" as the preferred name to be used everywhere\n Response: {\"property_firstName\":{\"propertyId\":\"firstName\",\"propertyNewValueType\":\"textarea\",\"propertyNewValue\":\"Pri\",\"reasoning\":\"The new information explicitly states 'Update contact's first name to Pri as the preferred name to be used everywhere'. The current object state already shows the first name as 'Pri', so this is a confirmation of the existing value.\"},\"completed\":true,\"userQuestions\":\"\",\"createContextNote\":false}",
"propertyUpdates": [{"value": "Pri", "sources": null, "objectId": "priya.patel@example.com", "aiFeature": null,
"reasoning": "The new information explicitly states 'Update contact's first name to Pri as the preferred name to be used everywhere'. The current object state already shows the first name as 'Pri', so this is a confirmation of the existing value.", "__typename": "PropertyUpdate", "objectType": "native_contact", "propertyId": "firstName", "workspaceId": "7d014738-da3a-4c11-aced-2ce58715901d", "propertyType": "textarea", "aiFeatureVersion": null}]}

*/

import { alpha, Box, Typography } from '@mui/material'
import { IconCheck } from '@tabler/icons-react'

import useObjects from 'src/components/Objects/useObjects'
import Row from 'src/components/Row/Row'

const ThreadUpdate = ({ update }: { update: any }) => {
  const { propertyDefinitions } = useObjects()

  const containerSx = {
    px: '12px',
    py: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    '& .thread-update-row': {
      alignItems: 'flex-start',
      gap: 2,
    },
    '& .thread-update-headline': {
      width: '100%',
      '& .MuiTypography-root': {
        fontSize: '13px',
        letterSpacing: '-0.22px',
        color: (theme) => theme.palette.text.secondary,
        borderBottom: '1px dashed',
        borderColor: (theme) => alpha(theme.palette.text.secondary, 0.5),
        mb: '6px',
        fontWeight: 500,
        opacity: 0.8,
        '& .value': {
          fontWeight: 600,
          color: (theme) => theme.palette.text.primary,
          opacity: 1,
        },
      },
    },
    '& .thread-update-reasoning': {
      fontSize: '11px',
      fontStyle: 'italic',
      opacity: 0.8,
    },

    '& .thread-message-tool-icon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '52px',
      height: '52px',
      backgroundColor: (theme) => alpha(theme.palette.success.main, 0.1),
      borderRadius: '8px',
      flexShrink: 0,

      '& .tabler-icon': {
        color: (theme) => theme.palette.success.main,
      },
    },
  }

  return (
    <Box
      className="thread-update"
      sx={containerSx}
    >
      {update.propertyUpdates.map((property: any) => (
        <Row
          key={`${property.objectId}-${property.propertyId}`}
          className="thread-update-row"
        >
          <Box className="thread-message-tool-icon">
            <IconCheck
              size={24}
              stroke={2.8}
            />
          </Box>
          <Box>
            <Row className="thread-update-headline">
              <Typography>
                Updated{' '}
                {
                  propertyDefinitions[property.objectType][property.propertyId]
                    .name
                }{' '}
                to <span className="value">{property.value}</span>
              </Typography>
            </Row>
            <Typography className="thread-update-reasoning">
              {property.reasoning}
            </Typography>
          </Box>
        </Row>
      ))}
    </Box>
  )
}

export default ThreadUpdate
